import _extends from "@babel/runtime/helpers/extends";
import { createMemoryHistory } from 'history';
import React, { useMemo } from 'react';
import { RouterContainer } from '../router-store';
export const Router = ({
  basePath,
  children,
  history,
  initialRoute,
  isGlobal = true,
  plugins,
  onPrefetch,
  routes
}) => {
  return /*#__PURE__*/React.createElement(RouterContainer, {
    basePath: basePath,
    history: history,
    initialRoute: initialRoute,
    isGlobal: isGlobal,
    onPrefetch: onPrefetch,
    plugins: plugins != null ? plugins : [],
    routes: routes
  }, children);
};
export function MemoryRouter(props) {
  var _props$plugins;
  const history = useMemo(() => createMemoryHistory(props.location ? {
    initialEntries: [props.location]
  } : {}), [props.location]);
  return /*#__PURE__*/React.createElement(Router, _extends({}, props, {
    history: history,
    isGlobal: false,
    plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
  }));
}